import { mapToCamelCase, mapToSnakeCase } from '@consigli/utils';
/**
 * RTK Query mutations for the qa-agent upload flow.
 *
 * core-api validates the B2C JWT, owns the submission record, and mints the SAS
 * upload URL returned here; the browser uploads the file bytes directly to blob
 * storage (see `useChunkedBlobUpload`). On `complete`, core-api enqueues a job
 * for the qa-agent worker over Service Bus — there is no synchronous call to
 * qa-agent.
 */
export const qaSubmissionApiEndpoints = (builder, coreApiBaseUrl) => ({
    requestQaSubmissionUploadIntent: builder.mutation({
        query: (body) => ({
            url: `${coreApiBaseUrl}/qa-agent/submissions/upload-intent`,
            method: 'POST',
            body: mapToSnakeCase(body),
        }),
        transformResponse: (resp) => mapToCamelCase(resp),
    }),
    completeQaSubmission: builder.mutation({
        query: ({ submissionId }) => ({
            url: `${coreApiBaseUrl}/qa-agent/submissions/${submissionId}/complete`,
            method: 'POST',
            body: {},
        }),
        transformResponse: (resp) => mapToCamelCase(resp),
    }),
});
